import Intercom from '@intercom/messenger-js-sdk';
import Config from 'hooks/config';
import dayjs from 'utils/dayjs';

/**
 * Interface representing the user object required for Intercom integration.
 */
interface IntercomUser {
    user_id: string; // The ID of the user.
    email: string; // The email address of the user.
    date_joined: string; // The sign-up date of the user in Unix timestamp (in seconds).
}

/**
 * Utilities to manage Intercom integration.
 * Provides methods to initialize Intercom for user tracking and messaging.
 */
const IntercomUtils = {
    /**
     * Initializes the Intercom integration with the provided user information.
     *
     * @param {IntercomUser} user - The user object containing the necessary information for Intercom integration.
     * @returns {void}
     *
     * @example
     * const user: IntercomUser = {
     *    user_id: '123',
     *    email: 'example@example.com',
     *    date_joined: '2021-01-29T21:42:08.398878Z'
     * };
     *
     * IntercomUtils.init(user);
     */
    init(user: IntercomUser): void {
        /* eslint-disable camelcase */
        Intercom({
            app_id: Config.intercomAppId,
            user_id: user.user_id,
            name: user.email,
            email: user.email,
            created_at: dayjs(user.date_joined).unix(),
        });
        /* eslint-enable camelcase */
    },
};

export default IntercomUtils;
